module.exports = __webpack_public_path__ + "static/media/play-shadow.823eb7d2.webp";